import React from 'react'
import PropTypes from 'prop-types'
import { delay } from '../helper/time'
import { CSSTransition, TransitionGroup } from 'react-transition-group'

import './gallery.css'

export class Gallery extends React.Component {
	state = {}

	startSlideShow = () => {
		const {pics} = this.props
		this.setState({
			show: [...pics].reverse()
				.map((pic, index) => ({
					...pic,
					angle: index === pics.length - 1 ? 0 : Math.round(Math.random() * 60 - 30),
				})),
		})
	}

	endSlideShow = () => this.setState({show: undefined})

	moveSlide = slide => async e => {
		e.stopPropagation()
		this.setState(({show}) => ({
			show: show.filter(x => x !== slide)
				.map((slide, index) => index === show.length -2 ? {...slide, angle: 0} : slide),
		}))
		await delay(500)()
		this.setState(({show}) => ({
			show: show && [{...slide, angle: Math.round(Math.random() * 60 - 30)}, ...show],
		}))
	}

	renderSmallPics(){
		const {pics, size} = this.props
		const imgStyle = {
			maxWidth: size,
			maxHeight: size,
		}
		return <div className="gallery" onClick={this.startSlideShow}>
			{pics
				.filter((pic, index) => index < 3)
				.reverse()
				.map(({src}, index) => <div key={index}>
					<img src={src} alt="" style={imgStyle} />
				</div>)}
		</div>
	}

	renderBigPics(){
		const {show} = this.state
		return show.map(slide => {
			const {src, angle} = slide
			return <CSSTransition key={`csst${src}`} timeout={500} classNames="slideshow">
				<div key={src} className="slideshow" onClick={this.endSlideShow}>
					<div key={`g${src}`} style={{
						transform: `rotate(${angle}deg)`,
					}} onClick={this.moveSlide(slide)}>
						<img src={src} alt="" />
					</div>
				</div>
			</CSSTransition>
		})
	}

	// FIXME: move pics around!!!
	render() {
		const {show} = this.state
		return <React.Fragment>
			{this.renderSmallPics()}
			{show && <div className="slideshowgray" onClick={this.endSlideShow} />}
			<TransitionGroup>
				{show && this.renderBigPics()}
			</TransitionGroup>
		</React.Fragment>
	}

	static propTypes = {
		pics: PropTypes.arrayOf(PropTypes.shape({
			src: PropTypes.string.isRequired,
		})).isRequired,
		size: PropTypes.string,
	}

	static defaultProps = {
		size: '140px',
	}
}

export const connect = RenderComponent => ({children, size}) => {
	const pics = children
		.filter(({type}) => type === 'a')
		.map(({props}) => props)
	return <RenderComponent pics={pics} size={size} />
}

export default connect(Gallery)



// WEBPACK FOOTER //
// ./src/components/gallery.jsx